
import { h, Fragment } from 'preact'; /** @jsx h */

//import { lazy } from 'preact-iso';
import { useLocation } from 'preact-iso';

import { Page, Course } from '@pyqml/model';
import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

import { useEnvironment } from "../app/Environment";
import { useCacheableQueryProvider } from "../app/CacheableQueryProvider";
import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';
import { Content } from "../components/Content";
import { ContentItem } from "../components/ContentItem";

import { SubscribeSection } from '../glue/SubscribeSection';


import { BlogCover } from '../components/BlogCover';
import { WikiCourseCombi } from '../components/WikiCourseCombi';

export const CoursePage = (props) => {
    
    const { cacheableQuery } = useCacheableQueryProvider();
    const { baseUrl, imageUrl, subdomain } = useEnvironment();
    const location = useLocation();

    const slug = location.path.substring(location.path.lastIndexOf("/") + 1);

    // fetch the "teaser" modules
    const [result, refetch, count] = cacheableQuery?.({
        method: "POST",
        endpoint: ROUTES.CLOUDAPI_PUBLIC_GET_COURSE,
        queryData: {
            subdomain: props.group,
            slug: slug
        },
        reloadOn: [location, props.group]
    });

    const [resultWiki, refetchWiki, countWiki] = cacheableQuery?.({
        method: "POST",
        endpoint: ROUTES.CLOUDAPI_PUBLIC_GET_PUBLISHED_WIKI,
        queryData: {
            subdomain: subdomain,
            slug: slug,
            draft: props.draft
        },
        reloadOn: [location, props.group]
    });

    if (result?.data === undefined || resultWiki?.data === undefined) {
        return <Layout.Stacked>
            <Fragment as="Section">
                <BlogCover title="Loading..." subtitle="Please wait..." />
            </Fragment>
        </Layout.Stacked>
    }

    const { course, pageAbstracts } = result?.data ?? { course: undefined, pageAbstracts: undefined };
    
    console.log("CoursePage", course, pageAbstracts, resultWiki)

    
    if (resultWiki?.data && result?.data) {
        return <WikiCourseCombi courseData={result.data} wikiData={resultWiki.data}/>;
    }

    return <Layout.Stacked>
        
        {
            course && <Fragment as="Section">
                <BlogCover  {...course} />
                <Content >
                    {course?.abstractImage && <img src={ `${imageUrl}/${course?.abstractImage}` } alt={ course?.abstractImageAlt ?? "" }></img> }
        
                </Content>
            </Fragment>
        }
        
        <Layout.Section weight="full">
            <Content >
                <ContentItem contentId={"contentElement"} text={course?.content ?? ""} paywalled={""} />
                
            
            </Content>
        
        </Layout.Section>
        
        <Layout.Section weight="full">
            <Subheader title="In this Module" />
            <List.Standard>
            {
                    pageAbstracts?.map((page: Page.IPage) => (
                        <List.Item
                            title={ page.title }
                            abstract={ page.abstract }
                            image={ page.abstractImage ? `${imageUrl}/${page.abstractImage}` : undefined}
                            linkTo={ `${baseUrl}/${page.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish( page.orig_revision ? page.orig_revision : page.revision ) }
                            readingTime={ page.readingTime ?? undefined }
                        />
                    ))
                }
                
            </List.Standard>
            
        
        </Layout.Section>
        
        <SubscribeSection as="Section"/>

        
    </Layout.Stacked>
            
}
  
